import { render, staticRenderFns } from "./Fragments.vue?vue&type=template&id=7a81fa30&scoped=true"
import script from "./Fragments.vue?vue&type=script&lang=js"
export * from "./Fragments.vue?vue&type=script&lang=js"
import style0 from "./Fragments.vue?vue&type=style&index=0&id=7a81fa30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a81fa30",
  null
  
)

export default component.exports